var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layouts"},[_c('navbar'),_c('main',{staticClass:"app_content"},[_vm._t("default")],2),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }